import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin: 96px 0 0 0;
    padding: 0 48px;
    width: 100%;
    height: calc(100vh - 152px);
    overflow: auto;
`;

function BodyWithBreadcrumb({ children, ...rest }) {
    return <Container {...rest}>{children}</Container>;
}

export default BodyWithBreadcrumb;
